import { Base } from '../base/index.js';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'select';

/**
 * Class Select.
 */
export class Select extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  connectedCallback() {
    this.getElements();
    this.isOpen = false;
  }

  /**
   * getElements
   */
  getElements() {
    this.btn = this.querySelector('button');
    this.list = this.querySelector('.select-list');

    this.btn.addEventListener('click', this.onBtnClick.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
  }

  /**
   * onClick
   */
  onBtnClick() {
    if (this.isOpen) {
      return this.close();
    }

    return this.open();
  }

  /**
   * Close
   */
  close() {
    this.list.classList.remove('active');
    this.isOpen = false;
  }

  /**
   * Open
   */
  open() {
    this.list.classList.add('active');
    this.isOpen = true;

    document.addEventListener('click', this.onClickOutside.bind(this));
  }

  /**
   * @param {object} event
   * @param {String} event.key
   */
  onKeyup({ key }) {
    if (this.isOpen && key === 'Escape') {
      this.close();
    }
  }

  /**
   * on Click Outside
   * @param {object} event
   * @param {*} event.target
   */
  onClickOutside({ target }) {
    if (!this.contains(target)) {
      this.close();
    }
    document.removeEventListener('click', this.onClickOutside);
  }
}

export default Select;
